/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

/**
 * Column value type.
 */
export type PatchDataLibraryCollectionFieldRequestValueType = typeof PatchDataLibraryCollectionFieldRequestValueType[keyof typeof PatchDataLibraryCollectionFieldRequestValueType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchDataLibraryCollectionFieldRequestValueType = {
  text: 'text',
  number: 'number',
  boolean: 'boolean',
  date: 'date',
} as const;
